import api from 'API/index'

import { SET_PUBLIC_INFO } from '../mutation-types'

import { cachedPublicInfo, cachedKeysData, cachedTypesInfo, cachedProjectsInfo, cachedDetailsInfo, cachedGroupLabel, cachedLabelInfo } from 'API/cacheService'

const state = {
  publicInfo: cachedPublicInfo.load() || cachedKeysData.publicInfo
}

const getters = {
  publicInfo: (state, getters) => {
    return state.publicInfo
  },
  // 遍历项目数组，通过id获取name
  getUserProjectsName: (state, getters) => (id) => {
    return state.publicInfo.projects.find(project => {if (project.pid === id) {return project.xname}})
  },
}

const mutations = {
  [SET_PUBLIC_INFO] (state, data) {
    state.publicInfo = data
  }
}

const actions = {
  /**
   * 更新辅助数据
   */
  setPublicInfo (store, params) {
    return api.getPublicInfo(params)
      .then((data) => {
        let publicInfo = {
          projects: data.data.projects,
          types: data.data.types,
          details: data.data.details,
          groupLabel: data.data.groupLabel,
          label: data.data.label,
          userRecovery: store.state.publicInfo.userRecovery,
          srcUrl: data.data.srcUrl
        }
        cachedPublicInfo.save(publicInfo)
        store.commit(SET_PUBLIC_INFO, publicInfo)
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}


// WEBPACK FOOTER //
// ./src/store/modules/common.js